export default __webpack_public_path__ + "images/logo_black-5b5349b3e455a40f09e7bef774559065.svg";